<template>
  <div class="main_wrap">
    <header>
      <div class="search-bar">
        <el-input
          class="search-input"
          placeholder="请输入课程或资源名查询"
          clearable
          v-model="keywordInput"
          maxlength="20"
          @keyup.enter.native="refreshSearch()"
        >
          <img
            slot="prefix"
            class="search-icon"
            src="@/assets/icons/icon_search.png"
          />
          <el-button
            slot="suffix"
            class="search-button"
            type="primary"
            @click="refreshSearch()"
          >
            搜索
          </el-button>
        </el-input>
        <div class="search-result">
          为您查询到 <span>{{ searchList.total }}</span> 个与“
          <span> {{ $route.query.keywords }}</span
          >”相关的内容
        </div>
      </div>
      <div class="tab-bar">
        <div class="tab-list">
          <el-tabs v-model="searchType" @tab-click="chooseType">
            <el-tab-pane name="all">
              <div class="tab-title" slot="label">
                <img
                  :src="
                    require(`@/assets/icons/icon_search_all${
                      searchType == 'all' ? '_active' : ''
                    }.png`)
                  "
                />
                全部
              </div>
            </el-tab-pane>
            <el-tab-pane name="course">
              <div class="tab-title" slot="label">
                <img
                  :src="
                    require(`@/assets/icons/icon_search_course${
                      searchType == 'course' ? '_active' : ''
                    }.png`)
                  "
                />
                课程
              </div>
            </el-tab-pane>
            <el-tab-pane name="attachments">
              <div class="tab-title" slot="label">
                <img
                  :src="
                    require(`@/assets/icons/icon_search_attachments${
                      searchType == 'attachments' ? '_active' : ''
                    }.png`)
                  "
                />
                资源
              </div>
            </el-tab-pane>
          </el-tabs>
        </div>
        <div class="tab-select">
          <div
            class="tab-select-sort"
            :class="{ sortActive: item.index == sort }"
            v-for="(item, index) in sortOption"
            :key="index"
            @click="changeSort(item)"
          >
            <div
              class="tab-select-sort-item"
              v-if="item.uncourseShow || searchType == 'course'"
            >
              {{ item.label }}
            </div>
          </div>
          <el-popover
            placement="bottom"
            popper-class="resource-popover"
            width="fit-content"
            v-model="siftShow"
          >
            <div class="checkbox-title">
              课程分类
              <img
                src="@/assets/icons/icon_close.png"
                @click="siftShow = false"
              />
            </div>
            <el-checkbox-group v-model="courseTypeCheckbox">
              <div class="checkbox-cell">
                <div class="cell-title">省精品课程</div>
                <div class="cell-content">
                  <div
                    class="cell-item"
                    v-for="(item, index) in formatCourseTypeList"
                    :key="index"
                  >
                    <el-checkbox-button
                      :label="item.type"
                      :key="item.type"
                      v-if="!item.provinceFlag"
                    >
                      {{ item.typeName }}
                    </el-checkbox-button>
                  </div>
                </div>
              </div>
              <div class="checkbox-cell">
                <div class="cell-title">省级课程</div>
                <div class="cell-content">
                  <div
                    class="cell-item"
                    v-for="(item, index) in formatCourseTypeList"
                    :key="index"
                  >
                    <el-checkbox-button
                      :label="item.type"
                      :key="item.type"
                      v-if="item.provinceFlag"
                    >
                      {{ item.typeName }}
                    </el-checkbox-button>
                  </div>
                </div>
              </div>
            </el-checkbox-group>
            <template v-if="searchType == 'course'">
              <div class="checkbox-title">适用年级</div>
              <el-checkbox-group v-model="gradeCheckbox">
                <div class="checkbox-cell">
                  <div class="cell-title">小学</div>
                  <div class="cell-content">
                    <div
                      class="cell-item"
                      v-for="(item, index) in gradeList"
                      :key="index"
                    >
                      <template v-if="parseInt(item.dictValue) <= 6">
                        <el-checkbox-button
                          :label="item.dictValue"
                          :key="item.dictValue"
                        >
                          {{ item.dictLabel }}
                        </el-checkbox-button>
                      </template>
                    </div>
                  </div>
                </div>
                <div class="checkbox-cell">
                  <div class="cell-title">初中</div>
                  <div class="cell-content">
                    <div
                      class="cell-item"
                      v-for="(item, index) in gradeList"
                      :key="index"
                    >
                      <el-checkbox-button
                        :label="item.dictValue"
                        :key="item.dictValue"
                        v-if="
                          parseInt(item.dictValue) > 6 &&
                          parseInt(item.dictValue) <= 9
                        "
                      >
                        {{ item.dictLabel }}
                      </el-checkbox-button>
                    </div>
                  </div>
                </div>
              </el-checkbox-group>
            </template>
            <div class="popover-tools">
              <el-button class="btn" plain @click="resetSift">重置</el-button>
              <el-button class="btn check" type="primary" @click="checkSift"
                >确定</el-button
              >
            </div>

            <template slot="reference">
              <div class="tab-select-choose">
                <div
                  class="empty"
                  v-if="courseTypeValue.length == 0 && gradeValue.length == 0"
                >
                  筛选 <img src="@/assets/icons/icon_sift.png" />
                </div>
                <div class="active" v-else>
                  筛选：
                  <div class="chosen">
                    {{ getChosenSift() }}
                  </div>
                  <img src="@/assets/icons/icon_sift.png" />
                  <img
                    class="clear"
                    src="@/assets/icons/icon_close_background.png"
                    @click.stop="resetSift"
                  />
                </div>
              </div>
            </template>
          </el-popover>
        </div>
      </div>
    </header>
    <main>
      <section>
        <div class="resource-type-bar" v-if="searchType == 'attachments'">
          <div
            class="resource-type-item"
            :class="{ active: resourceType.indexOf(item.value) > -1 }"
            v-for="item in resourceTypeList"
            :key="item.index"
            @click="changeResourceType(item)"
          >
            {{ item.label }}
          </div>
        </div>
        <div class="resource-list">
          <template v-if="searchList.records && searchList.records.length > 0">
            <div
              class="resource-item"
              v-for="(item, index) in searchList.records"
              :key="index"
            >
              <div
                class="item-content"
                v-if="item.bizType == 'course'"
                @click="toCourse(item)"
              >
                <div class="resource-wrap">
                  <el-image
                    class="resource-cover"
                    :src="item.coverImgUrls[0] || ''"
                    fit="cover"
                  >
                    <div class="error_img" slot="error" />
                  </el-image>
                </div>
                <div class="resource-content">
                  <div class="resource-button">查看课程</div>
                  <div class="course-title">
                    <div
                      v-html="heightLight(item.name, $route.query.keywords)"
                    ></div>
                    <div class="tip">{{ item.lessonCount || 0 }}节课</div>
                  </div>
                  <div class="resource-detail">
                    <div class="detail-item">
                      分类：{{
                        item.courseTypeName || item.provinceCourseTypeName
                      }}
                    </div>
                    <div class="detail-item">年级：{{ getGrade(item) }}</div>
                    <div class="detail-item">
                      <span>点赞：{{ item.userLikeCount || 0 }}</span>
                      <span>收藏：{{ item.userFavoriteCount || 0 }}</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="item-content" v-else @click="toResource(item)">
                <div class="resource-wrap">
                  <el-image
                    class="resource-cover"
                    :src="
                      require(`@/assets/images/image_${getType(
                        item.suffix
                      )}.png`)
                    "
                    fit="cover"
                  >
                    <div class="error_img" slot="error" />
                  </el-image>
                  <div class="tip">{{ item.resourceTypeName }}</div>
                </div>
                <div class="resource-content">
                  <div class="resource-button">查看资源</div>
                  <div
                    class="download"
                    @click.stop="downloadResource(item)"
                    v-if="
                      loginStatus &&
                      item.resourceType == 'Design' &&
                      (getType(item.suffix) == 'word' ||
                        getType(item.suffix) == 'pdf')
                    "
                  >
                    <i class="el-icon-bottom"></i>
                    下载
                  </div>
                  <div
                    class="resource-title"
                    :title="item.resourceName"
                    v-html="
                      heightLight(item.resourceName, $route.query.keywords)
                    "
                  ></div>
                  <div class="resource-detail">
                    <div class="detail-item hover" @click.stop="toCourse(item)">
                      课程：{{ item.name }}
                    </div>
                    <div class="detail-item">课节：{{ item.lessonName }}</div>
                    <template v-if="item.teachingAuxiliaryId">
                      <div class="detail-item">
                        <span>科目：{{ item.subjectName || "暂无" }}</span>
                        <span>版别：{{ item.editionTypeName || "暂无" }}</span>
                      </div>
                    </template>
                  </div>
                </div>
              </div>
            </div>
          </template>
          <template v-else>
            <div class="empty">
              <img src="@/assets/images/searchEmpty.png" />
              <span>没有找到符合条件的结果</span>
            </div>
          </template>
          <el-pagination
            background
            class="page_nav"
            layout="prev, pager, next"
            :page-size="pageSize"
            v-if="total > 8"
            @current-change="pageChange"
            :current-page="pageNo"
            :total="total"
          />
        </div>
      </section>
      <aside>
        <div class="aside-header">
          <div class="title">历史记录</div>
          <div class="clear" @click="deleteHistory()">
            全部清除 <img src="@/assets/icons/icon_clear.png" />
          </div>
        </div>
        <div class="aside-content">
          <template v-if="historyList && historyList.length > 0">
            <div
              class="history-item"
              v-for="item in historyList"
              :key="item.id"
              @click="historySearch(item)"
            >
              <div class="content">
                <span class="name" :title="item.content">{{
                  item.content
                }}</span>
                <span>{{ item.updateTime.split(" ")[0] }}</span>
              </div>
              <div
                class="delete"
                @click.stop="deleteHistory('single', item.id || item.content)"
              >
                <img src="@/assets/icons/icon_close.png" />
              </div>
            </div>
          </template>
          <template v-else>
            <Empty text="暂无历史记录" :height="28" />
          </template>
        </div>
      </aside>
    </main>
  </div>
</template>

<script>
import {
  searchResource,
  visitorSearchResource,
  getSearchHistory,
  deleteHistory,
  getSearchDisc,
  getProvinceType,
  getResourceInfo,
  downloadSubjectSource,
  downloadSource,
} from "@/api/course";
import { getGrade } from "@/utils/common";
import Empty from "@/components/empty.vue";
import base64url from "base64url";

export default {
  name: "resource",
  components: {
    Empty,
  },
  data: function () {
    return {
      //搜索结果
      searchList: [],
      //历史记录
      historyList: [],
      //搜索框
      keywordInput: "",
      //搜索时使用的
      keywordSearch: "",
      //tab
      searchType: "all",
      //排序
      sort: 0,
      //排序写死的选项
      sortOption: [
        {
          index: 0,
          label: "综合排序",
          value: "",
          uncourseShow: true,
        },
        {
          index: 1,
          label: "最新发布",
          value: "create_time desc",
          uncourseShow: true,
        },
        {
          index: 2,
          label: "最受欢迎",
          value: "user_like_count desc",
          uncourseShow: false,
        },
      ],
      //分页
      total: 0,
      pageNo: 1,
      pageSize: 8,
      //资源类型
      resourceType: [],
      //资源类型
      resourceTypeList: [
        {
          index: 0,
          label: "教学设计",
          value: "Design",
        },
        {
          index: 1,
          label: "课件/教学视频",
          value: "Courseware",
        },
        {
          index: 2,
          label: "拓展资源",
          value: "Extension",
        },
      ],
      //筛选框是否展示
      siftShow: false,
      //筛选后的真正值
      courseTypeValue: [],
      gradeValue: [],
      //筛选里checkbox的值
      courseTypeCheckbox: [],
      gradeCheckbox: [],
      //筛选获取的值
      courseTypeList: [],
      gradeList: [],
    };
  },
  computed: {
    loginStatus() {
      return this.$store.state.AuthModule.loginStatus;
    },
    formatCourseTypeList() {
      let formatTypeList = [];
      this.courseTypeList.map((item) => {
        if (item.childrenType.length > 0) {
          formatTypeList.push(...item.childrenType);
        } else {
          item.provinceFlag = true;
          formatTypeList.push(item);
        }
      });
      return formatTypeList;
    },
  },
  methods: {
    loadData() {
      const { keywords } = this.$route.query;
      this.keywordInput = keywords;
      this.getOptions();
      this.refreshSearch();
    },
    //搜索
    async search() {
      if (this.keywordSearch) {
        const params = {
          bizType: this.searchType == "all" ? "" : this.searchType,
          content: this.keywordSearch,
          courseTypeList: this.courseTypeValue,
          gradeList: this.gradeValue,
          pageNo: this.pageNo,
          pageSize: this.pageSize,
          resourceTypeList: this.resourceType,
          sortFields: this.sortOption[this.sort].value,
        };
        const fetch = this.loginStatus ? searchResource : visitorSearchResource;
        const loading = this.$loading({
          lock: true,
          text: "搜索中",
        });
        const data = await fetch(params);
        if (this.$route.query.keywords != this.keywordSearch) {
          this.$router.replace({ query: { keywords: this.keywordSearch } });
        }
        //未登录状态要将历史记录保存在本地
        if (!this.loginStatus) {
          const date = new Date(Date.now());
          const Y = date.getFullYear() + "-";
          const M =
            (date.getMonth() + 1 < 10
              ? "0" + (date.getMonth() + 1)
              : date.getMonth() + 1) + "-";
          const D = date.getDate() + " ";
          const h = date.getHours() + ":";
          const m = date.getMinutes() + ":";
          const s = date.getSeconds();
          const historyItem = {
            content: this.keywordSearch,
            updateTime: Y + M + D + h + m + s,
          };
          let localHistory = JSON.parse(localStorage.getItem("searchHistory"));
          if (localHistory && localHistory.length > 0) {
            const index = localHistory.findIndex((item) => {
              return item.content == this.keywordSearch;
            });
            if (index > -1) {
              localHistory.splice(index, 1);
            }
            if (localHistory.length == 5) {
              localHistory.pop();
            }
            localHistory.unshift(historyItem);
          } else {
            localHistory = [historyItem];
          }
          localStorage.setItem("searchHistory", JSON.stringify(localHistory));
        }
        this.getHistoryList();
        this.searchList = data;
        this.total = parseInt(data.total);
        loading.close();
      } else {
        this.$message({
          type: "error",
          customClass: "errorTips",
          message: "搜索内容不能为空哟",
        });
      }
    },
    //修改筛选后的搜索，不会使用输入框里的关键字，只将分页改为第一页
    changeSearch() {
      this.pageNo = 1;
      this.search();
    },
    //从输入框获取关键字来重新搜索，会清空所有筛选条件
    refreshSearch() {
      this.keywordSearch = this.keywordInput;
      this.sort = 0;
      this.searchType = "all";
      this.resourceType = [];
      //筛选条件清空
      this.resetSift();
    },
    // 源字符串，要高亮的片段 (可百度 )
    //str 要传入的字符串  key 代表要高亮的字符串
    heightLight(str, key) {
      const reg = new RegExp(key, "ig");
      return str.replace(reg, (val) => {
        return `<span style="background-image: linear-gradient( to bottom , #ffffff 65%, rgba(47,165,255,0.3) 0); color : #2fa5ff">${val}</span>`;
      });
    },
    //获取用户历史记录
    async getHistoryList() {
      let data = [];
      if (this.loginStatus) {
        data = await getSearchHistory();
      } else {
        data = JSON.parse(localStorage.getItem("searchHistory"));
      }
      this.historyList = data;
    },
    //获取筛选框选项
    async getOptions() {
      await getSearchDisc("grade").then((data) => {
        this.gradeList = data;
      });
      await getProvinceType().then((data) => {
        this.courseTypeList = data;
      });
    },
    //获取已选的选项中文
    getChosenSift() {
      let result = [];
      this.formatCourseTypeList.map((item) => {
        if (this.courseTypeValue.indexOf(item.type) > -1) {
          result.push(item.typeName);
        }
      });
      this.gradeList.map((item) => {
        if (this.gradeValue.indexOf(item.dictValue) > -1) {
          result.push(item.dictLabel);
        }
      });
      return result.join(";");
    },
    //确定筛选选择
    checkSift() {
      this.courseTypeValue = this.courseTypeCheckbox;
      this.gradeValue = this.gradeCheckbox;
      this.changeSearch();
      this.siftShow = false;
    },
    //重置筛选选择
    resetSift() {
      this.courseTypeCheckbox = [];
      this.gradeCheckbox = [];
      this.courseTypeValue = [];
      this.gradeValue = [];
      this.changeSearch();
    },
    //历史记录点击搜索
    async historySearch(item) {
      //如果历史关键词与现在搜索的关键词一致，则无事发生。
      if (item.content == this.keywordInput) {
        return;
      }
      this.keywordInput = item.content;
      await this.refreshSearch();
      this.getHistoryList();
    },
    //删除历史记录
    //已登录的情况下，ids表示的是搜索记录的id；游客模式下，ids表示的是搜索的content
    deleteHistory(type = "all", ids) {
      if (this.loginStatus) {
        const id = type == "all" ? "" : ids;
        deleteHistory(id).then(() => {
          this.getHistoryList();
        });
      } else {
        let localHistory = JSON.parse(localStorage.getItem("searchHistory"));
        if (type == "all") {
          localStorage.removeItem("searchHistory");
        } else {
          const index = localHistory.findIndex((item) => {
            return item.content == ids;
          });
          localHistory.splice(index, 1);
          localStorage.setItem("searchHistory", JSON.stringify(localHistory));
        }
        this.getHistoryList();
      }
    },
    //选择资源类型
    chooseType(tab, event) {
      if (tab.name != "course") {
        if (this.sort == 2) {
          this.sort = 0;
        }
        this.gradeCheckbox = [];
        this.gradeValue = [];
      }
      this.changeSearch();
    },
    //修改排序规则
    changeSort(item) {
      this.sort = item.index;
      this.changeSearch();
    },
    //修改资源的具体分类
    changeResourceType(typeItem) {
      let arr = this.resourceType;
      const index = arr.indexOf(typeItem.value);
      if (index > -1) {
        arr.splice(index, 1);
      } else {
        arr.push(typeItem.value);
      }
      this.changeSearch();
    },
    //跳转课程
    toCourse(item) {
      if (item.teachingAuxiliaryId)
        this.$router.push(
          `/course/subjectDetail/${item.id}?teachingAuxiliaryId=${item.teachingAuxiliaryId}&from=search&keywords=${this.keywordInput}&target=resourse`
        );
      else
        this.$router.push(
          `/course/detail/${item.id}?from=search&keywords=${this.keywordInput}&target=resourse`
        );
    },
    //跳转资源
    toResource(item) {
      if (this.loginStatus) {
        getResourceInfo(item.channel, item.channelResourceId)
          .then((res) => {
            if (res.attachmentsDto) {
              console.log("智趣课后");
              //智趣课后资源
              const info = res.attachmentsDto;
              if (info.attachmentType == "ppt") {
                const data = {
                  name: "viewerIndex",
                  params: {
                    id: info.sourceId,
                    uid: info.id,
                  },
                };
                if (localStorage.getItem("googleCheck") == "true") {
                  window.open(this.$router.resolve(data).href, "_blank");
                } else {
                  this.$confirm(
                    "由于浏览器的兼容性限制，为保证课件最佳播放效果，建议使用“谷歌浏览器”查看课件",
                    {
                      distinguishCancelAndClose: true,
                      confirmButtonText: "好的",
                      cancelButtonText: "不再提醒",
                      center: true,
                    }
                  )
                    .then(() => {
                      window.open(this.$router.resolve(data).href, "_blank");
                    })
                    .catch((action) => {
                      if (action == "cancel") {
                        localStorage.setItem("googleCheck", true);
                      }
                    });
                }
              } else if (info.attachmentType == "word") {
                const url = info.attachmentPlayUrl;
                const data = {
                  name: "resViewer",
                  params: {
                    uid: info.id,
                    url: base64url.encode(url),
                  },
                  query: {
                    type: info.attachmentType,
                  },
                };
                window.open(this.$router.resolve(data).href, "_blank");
              } else if (info.attachmentType == "pdf") {
                const url = info.attachmentPlayUrl + "#toolbar=0";
                const data = {
                  name: "resViewer",
                  params: {
                    uid: info.id,
                    url: base64url.encode(url),
                  },
                  query: {
                    type: info.attachmentType,
                  },
                };
                window.open(this.$router.resolve(data).href, "_blank");
              } else if (
                info.attachmentType == "video" ||
                info.attachmentType == "audio"
              ) {
                const data = {
                  name: "videoPlay",
                  params: {
                    mediaId: info.attachmentMediaId,
                    uid: info.id,
                  },
                  query: {
                    type: info.attachmentType,
                  },
                };
                window.open(this.$router.resolve(data).href, "_blank");
              }
            } else {
              //作业辅导课||智慧作业的
              console.log("作业辅导课");
              const info = res.teachingAuxiliaryChapterResourceVo;
              const infoType = this.getType(info.suffix);
              if (infoType == "ppt") {
                const data = {
                  name: "viewerIndex",
                  params: {
                    id: info.bookId,
                    uid: info.id,
                  },
                  query: {
                    resourseType: 2,
                    textbookId: info.bookId,
                    chapterId: info.chapterId,
                    teachingAuxiliaryId: item.teachingAuxiliaryId,
                    mediaId: info.mediaId,
                  },
                };
                if (localStorage.getItem("googleCheck") == "true") {
                  window.open(this.$router.resolve(data).href, "_blank");
                } else {
                  this.$confirm(
                    "由于浏览器的兼容性限制，为保证课件最佳播放效果，建议使用“谷歌浏览器”查看课件",
                    {
                      distinguishCancelAndClose: true,
                      confirmButtonText: "好的",
                      cancelButtonText: "不再提醒",
                      center: true,
                    }
                  )
                    .then(() => {
                      window.open(this.$router.resolve(data).href, "_blank");
                    })
                    .catch((action) => {
                      if (action == "cancel") {
                        localStorage.setItem("googleCheck", true);
                      }
                    });
                }
              } else if (infoType == "word") {
                const url = info.playUrl;
                if (!url) {
                  throw "无资源播放地址";
                }
                const data = {
                  name: "resViewer",
                  params: {
                    uid: info.id,
                    url: base64url.encode(url),
                  },
                  query: {
                    type: infoType,
                    resourseType: 2,
                    textbookId: info.bookId,
                    chapterId: info.chapterId,
                    teachingAuxiliaryId: item.teachingAuxiliaryId,
                    mediaId: info.mediaId,
                  },
                };
                window.open(this.$router.resolve(data).href, "_blank");
              } else if (infoType == "pdf") {
                if (!info.playUrl) {
                  throw "无资源播放地址";
                }
                const url = info.playUrl + "#toolbar=0";
                const data = {
                  name: "resViewer",
                  params: {
                    uid: info.id,
                    url: base64url.encode(url),
                  },
                  query: {
                    type: infoType,
                    resourseType: 2,
                    textbookId: info.bookId,
                    chapterId: info.chapterId,
                    teachingAuxiliaryId: item.teachingAuxiliaryId,
                    mediaId: info.mediaId,
                  },
                };
                window.open(this.$router.resolve(data).href, "_blank");
              } else if (infoType == "video" || infoType == "audio") {
                let data = null;
                if (info.courseVideoTag) {
                  data = {
                    name: "microVideoPlay",
                    params: {
                      uid: info.id,
                    },
                    query: {
                      url: encodeURI(info.playUrl),
                      type: infoType,
                      teachingAuxiliaryId: item.teachingAuxiliaryId,
                    },
                  };
                } else {
                  data = {
                    name: "videoPlay",
                    params: {
                      mediaId: info.mediaId,
                      uid: info.id,
                    },
                    query: {
                      type: infoType,
                      resourseType: 2,
                      textbookId: info.bookId,
                      chapterId: info.chapterId,
                      teachingAuxiliaryId: item.teachingAuxiliaryId,
                      mediaId: info.mediaId,
                    },
                  };
                }
                console.log(data);
                window.open(this.$router.resolve(data).href, "_blank");
              }
            }
          })

          .catch((err) => {
            this.$message({
              type: "error",
              customClass: "errorTips",
              message: "资源出错，无法预览",
            });
          });
      } else {
        this.$confirm("如需查看更多优质课程资源，请登录后再查看。", "提示", {
          confirmButtonText: "去登录",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.$router.push(`/login`);
          })
          .catch((action) => {});
      }
    },
    //下载资源
    downloadResource(item) {
      console.log(item);
      const params = {
        courseName: item.name,
        id: item.channelResourceId,
      };
      const fetch =
        item.channel == "zqkh" ? downloadSource : downloadSubjectSource;
      fetch(params).then((data) => {
        const a = document.createElement("a");
        a.href = data;
        a.download = item.resourceName;
        a.click();
      });
    },

    //获取年级
    getGrade(course) {
      if (course.courseGradeTermList) {
        const gradeArr = course.courseGradeTermList.map((item) => {
          return item.grade;
        });
        return getGrade(gradeArr);
      } else return "暂无";
    },
    //获取封面地址,根据后缀判断类型
    getType(suf) {
      const lowSuf = suf.toLowerCase();
      let type = "";
      switch (lowSuf) {
        case "doc":
        case "docx":
          type = "word";
          break;
        case "pptx":
        case "ppt":
          type = "ppt";
          break;
        case "mp3":
        case "audio":
          type = "audio";
          break;
        case "mp4":
        case "video":
          type = "video";
          break;
        case "xls":
        case "xlsx":
          type = "excel";
          break;
        case "pdf":
          type = "pdf";
          break;
      }
      return type;
    },
    //换页逻辑
    pageChange(ev) {
      this.pageNo = ev;
      this.search();
    },
  },
  mounted() {
    this.loadData();
  },
};
</script>

<style lang="scss" scoped>
.main_wrap {
  header {
    background: #ffffff;
    //补足父元素padding带来的影响
    position: relative;
    bottom: 2rem;
    margin-bottom: -4rem;
    right: 8rem;
    padding: 0 8rem 1rem;
    box-sizing: border-box;
    width: calc(100% + 16rem);
    .search-bar {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      padding: 4rem 0 2rem;
      ::v-deep .search-input {
        width: 40%;
        .el-input__inner {
          height: 4rem;
          line-height: 4rem;
          border-radius: 0.4rem;
          background: $color-grey;
          padding: 0 4rem;
          font-size: 1.6rem;
          border: 0.1rem solid #dcdfe5;
        }
        .el-input__prefix {
          left: 1.5rem;
          display: flex;
          align-items: center;
          img {
            width: 1.7rem;
            height: 1.7rem;
          }
        }
        .el-input__suffix {
          right: 0.5rem;
          display: flex;
          align-items: center;

          .el-input__suffix-inner {
            display: flex;
            flex-direction: row-reverse;
            align-items: center;
            .search-button {
              height: 3rem;
              width: 8rem;
              font-size: 1.6rem;
              padding: 1.2rem 2rem;
              border-radius: 0.4rem;
              background-color: $color-primary;
              border: none;
              display: flex;
              align-items: center;
              justify-content: center;
            }
            .el-icon-circle-close:before {
              content: "\e79d";
            }
            .el-input__clear {
              font-size: 1.5rem;
              line-height: 1;
              width: 2.5rem;
            }
          }
        }
      }
      .search-result {
        margin-top: 2rem;
        color: #333333;
        font-size: 1.4rem;
        span {
          color: $color-primary;
        }
      }
    }

    .tab-bar {
      display: flex;
      justify-content: space-between;
      align-items: center;
      ::v-deep .tab-list {
        .tab-title {
          display: flex;
          align-items: center;
          img {
            width: 2.08rem;
            height: 2.08rem;
            margin-right: 0.65rem;
          }
        }

        .el-tabs__header {
          margin: 0;
        }
        .el-tabs__active-bar {
          height: 0.3rem;
        }
        .el-tabs__item {
          font-weight: normal;
          user-select: none;

          &:hover {
            color: #303133;
          }
        }
        .el-tabs__item.is-active {
          font-weight: bold;
        }
      }
      .tab-select {
        display: flex;
        align-items: center;
        color: #333333;
        font-size: 1.6rem;
        .tab-select-sort {
          cursor: pointer;
          margin-right: 1rem;
          user-select: none;
          border-radius: 0.6rem;

          .tab-select-sort-item {
            padding: 0.8rem 1.6rem;
          }
          &:hover {
            background: #f6f6f6;
          }
        }
        .sortActive {
          background: #f3f5f7;
          color: #333333 !important;
          // font-weight: bold;
        }

        .tab-select-choose {
          user-select: none;
          cursor: pointer;
          margin-left: 0.5rem;
          white-space: nowrap;
          .empty {
            display: flex;
            align-items: center;
          }
          .active {
            display: flex;
            align-items: center;
            background: #f3f5f7;
            padding: 0.5rem 1rem;
            border-radius: 0.52rem;
            position: relative;
            .chosen {
              max-width: 15rem;
              overflow: hidden;
              text-overflow: ellipsis;
            }
            .clear {
              position: absolute;
              width: 1.4rem;
              height: 1.4rem;
              right: -0.8rem;
              top: -0.8rem;
            }
          }
          img {
            position: relative;
            top: 0.1rem;
            margin-left: 0.5rem;
            width: 1.5rem;
            height: 1.5rem;
          }
        }
      }
    }
  }

  main {
    //抵消header的2rem上移 并保留2rem margin
    margin-top: 4rem;
    width: 100%;
    display: flex;
    box-sizing: border-box;

    section {
      flex: 1;
      //选择资源类型
      .resource-type-bar {
        display: flex;
        margin-bottom: 2rem;
        .resource-type-item {
          font-size: 1.6rem;
          color: #666666;
          border: 0.1rem solid #dcdcdc;
          background: #ffffff;
          padding: 0.5rem 1rem 0.6rem;
          border-radius: 0.4rem;
          margin-right: 2rem;
          cursor: pointer;
        }

        .active {
          border-color: #2fa5ff;
          color: $color-primary;
        }
      }
      //资源列表
      .resource-list {
        box-sizing: border-box;
        background: #ffffff;
        border-radius: 0.4rem;
        box-shadow: 0 0.1rem 0 0 #f1f2f4;
        min-height: 50rem;

        .resource-item {
          height: 16rem;
          width: 100%;
          padding: 0 2rem;
          box-sizing: border-box;
          border: 0.1rem solid #ffffff;

          .item-content {
            padding: 2rem 0;
            height: 100%;
            width: 100%;
            box-sizing: border-box;
            border-bottom: 0.1rem solid #f1f2f4;
            display: flex;
            align-items: center;
            cursor: pointer;

            //图片
            .resource-wrap {
              height: 100%;
              width: 20rem;
              margin-right: 2rem;
              position: relative;

              .tip {
                padding: 0.5rem 1rem;
                color: #ffffff;
                font-size: 1.4rem;
                background: rgba($color: #000000, $alpha: 0.5);
                box-sizing: border-box;
                border-radius: 1.6rem 0 0.4rem 0;
                position: absolute;
                bottom: 0;
                right: 0;
              }

              .resource-cover {
                width: 100%;
                height: 100%;
                border-radius: 0.4rem;
              }
            }
            //内容
            .resource-content {
              flex: 1;
              height: 100%;
              display: flex;
              position: relative;
              flex-direction: column;
              justify-content: space-between;
              //查看课程的按钮
              .resource-button {
                position: absolute;
                right: 0;
                top: 0;
                padding: 0.7rem 1.5rem;
                border: 0.1rem solid #dcdcdc;
                border-radius: 0.4rem;
                font-size: 1.6rem;
                color: #333333;

                &:hover {
                  color: #ffffff;
                  background: $color-primary;
                  border-color: $color-primary;
                }
              }
              //下载按钮
              .download {
                position: absolute;
                right: 1.5rem;
                bottom: 0;
                display: flex;
                align-items: center;
                font-size: 1.5rem;
                color: #333333;
                cursor: pointer;
                i {
                  margin-right: 0.2rem;
                }

                &:hover {
                  color: $color-primary;
                }
              }
              //课程标题
              .course-title {
                color: #000000;
                font-size: 1.8rem;
                font-weight: bold;
                display: flex;
                align-items: center;
                max-width: 80%;
                .tip {
                  font-size: 1.2rem;
                  color: #09a7ff;
                  padding: 0.5rem 1rem;
                  background: #e5f6fd;
                  border-radius: 0.4rem;
                  margin-left: 1rem;
                }
              }
              .resource-title {
                font-size: 1.8rem;
                font-weight: bold;
                color: #000000;
                max-width: 80%;
                overflow: visible;
                text-overflow: ellipsis;
                white-space: nowrap;
              }
              .resource-detail {
                //通用详细信息
                .detail-item {
                  font-size: 1.4rem;
                  color: #666666;
                  margin-top: 1rem;
                  span {
                    margin-right: 1.5rem;
                  }
                }
                .hover {
                  width: fit-content !important;
                  &:hover {
                    color: $color-primary;
                  }
                }
              }
            }
          }

          &:hover {
            box-shadow: 0rem 0rem 4rem 0rem rgba(213, 213, 213, 0.5);
            border-color: $color-grey;
            .item-content {
              border-color: #ffffff;
            }
          }
        }
        .empty {
          width: 100%;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          padding-top: 10rem;
          img {
            width: 28rem;
            height: 18rem;
          }
          span {
            font-size: 1.6rem;
            color: #666666;
          }
        }
      }

      .page_nav {
        display: table;
        margin: 0 auto;
        padding: 5rem 0;
      }
    }
    aside {
      box-sizing: border-box;
      margin-left: 2rem;
      width: 38rem;
      height: fit-content;
      background: #ffffff;
      border-radius: 0.4rem;
      padding: 2rem;
      .aside-header {
        display: flex;
        align-items: flex-end;
        justify-content: space-between;
        margin-bottom: 3rem;
        .title {
          font-size: 1.8rem;
          font-weight: bold;
          color: #000000;
        }
        .clear {
          font-size: 1.4rem;
          color: #666666;
          display: flex;
          align-items: center;
          cursor: pointer;
          img {
            margin-left: 0.5rem;
            width: 1.5rem;
            height: 1.5rem;
          }
        }
      }
      .aside-content {
        width: 100%;
        height: 28rem;
        .history-item {
          height: 1.6rem;
          width: 100%;
          padding-left: 0.2rem;
          box-sizing: border-box;
          border-radius: 0.1rem;
          margin: 2rem 0;
          display: flex;
          align-items: center;
          cursor: pointer;
          .content {
            flex: 1;
            display: flex;
            justify-content: space-between;
            font-size: 1.4rem;
            color: #333333;
            box-sizing: border-box;
            position: relative;
            width: calc(100% - 1.5rem);

            .name {
              max-width: 60%;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
          }
          .delete {
            margin-left: 0.5rem;
            width: fit-content;
            align-items: center;
            width: 1.5rem;
            height: 1.5rem;
            img {
              display: none;
              height: 100%;
              width: 100%;
            }
          }
          &:hover {
            .content {
              color: $color-primary;
            }
            .delete {
              img {
                display: block;
              }
            }
          }
        }
      }
    }
  }
}
</style>

<style lang="scss">
.resource-popover {
  box-sizing: border-box;
  padding: 2rem;
  margin-top: 1.2rem;

  .checkbox-title {
    font-size: 1.8rem;
    color: #333333;
    margin-bottom: 2rem;
    display: flex;
    justify-content: space-between;
    img {
      width: 1.95rem;
      height: 1.82rem;
      cursor: pointer;
    }
  }
  .popover-tools {
    margin-top: 2rem;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    .btn {
      margin-right: 2rem;
      border-width: 0.1rem;
      font-size: 1.4rem;
      border-radius: 0.4rem;
      padding: 1.2rem 2rem;
    }

    .check {
      background: $color-primary;
    }
    .el-button + .el-button {
      margin-left: 0;
    }
  }
  .checkbox-cell {
    margin-bottom: 1rem;
    .cell-title {
      font-size: 1.4rem;
      color: #000000;
      margin-bottom: 1rem;
    }
    .cell-content {
      display: flex;
      .cell-item {
        .el-checkbox-button__inner {
          margin-right: 1rem;
          margin-bottom: 1rem;
          border: 0.1rem solid #dcdcdc !important;
          border-radius: 0.4rem;
          padding: 1.2rem 2rem;
          font-size: 1.4rem;
        }

        .el-checkbox-button__inner:hover {
          color: $color-primary;
        }

        .is-checked .el-checkbox-button__inner {
          background: none;
          color: $color-primary;
          border: 0.1rem solid $color-primary !important;
          box-shadow: none;
        }
      }
    }
  }
}
</style>